import en from './en.yaml'
import zh from './zh.yaml'

export default { zh, en }

export * from './remote'
export * from './i18n'
